import { createReducer, on, Action } from '@ngrx/store';

import * as actions from './actions';
import { AppState } from '../shared/models';

const appReducer = createReducer<AppState>(
  {},
  on(actions.initialized, (state) => ({
    ...state,
    initialized: true,
  })),
  on(actions.setExternalUser, (state, { externalId, system, externalEntityTypeEnum }) => ({
    ...state,
    externalUser: {
      externalId,
      system,
      externalEntityTypeEnum,
    },
  })),
  on(actions.setProfileId, (state, { profileId }) => ({
    ...state,
    profileId,
  })),
  on(actions.setApplications, (state, { applications }) => ({
    ...state,
    applications: applications
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),
  on(actions.setApplicationGroups, (state, { applicationGroups }) => ({
    ...state,
    applicationGroups: applicationGroups
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),
  on(actions.setRoles, (state, { roles }) => ({
    ...state,
    roles: roles
      .concat()
      .sort((a, b) => (a.displayName > b.displayName ? 1 : b.displayName > a.displayName ? -1 : 0)),
  })),
  on(actions.setAccessRules, (state, { accessRules }) => ({
    ...state,
    accessRules,
  })),
  on(actions.setUseraccess, (state, action) => ({
    ...state,
    accessRules: [
      ...state.accessRules.filter(({ applicationKey }) => applicationKey !== action.applicationKey),
      { applicationKey: action.applicationKey, roleKey: action.roleKey },
    ],
  })),
  on(actions.setGroupUseraccess, (state, action) => ({
    ...state,
    accessRules: [
      ...state.accessRules,
      ...state.applications
        .filter((application) => application.applicationGroupId === action.groupId)
        .map((application) => ({
          applicationKey: application.key,
          roleKey: application.defaultRoleKey,
        })),
    ],
  })),
  on(actions.deleteGroupUseraccessSuccess, (state, action) => {
    const applications = state.applications
      .filter((application) => application.applicationGroupId === action.groupId)
      .map((application) => application.key);
    return {
      ...state,
      accessRules: [
        ...state.accessRules.filter(
          (accessRule) => applications.indexOf(accessRule.applicationKey) === -1,
        ),
      ],
    };
  }),
);

export const reducer = (state: AppState | undefined, action: Action) => appReducer(state, action);
